export const workflowStatusMap = {
  0: 'Waiting',
  1: 'Running',
  2: 'Finished',
  3: 'Failed',
  4: 'Cancelled',
  5: 'Interrupted',
  6: 'Operation limit excedeed',
  11: 'Cancelling'
};
